const tableTitleManagementBackups = {
  title: 'Gestão de Backups (App)',
  placeholder: 'Pesquisar',
};

export default tableTitleManagementBackups;
